<template>
  <div v-if="items && items.length > 0" class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>ID</th>
        <th>{{'invoice_from_to' | translate}}</th>
        <th>{{'bills' | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items">
        <td>{{item.id}}</td>
        <td>{{item.date_range_from}} - {{item.date_range_to}}</td>
        <td><a class="btn btn-success btn-sm" :href="item.summary_path" target="_blank"><i class="fa fa-cloud-download mr-5"></i>Download CSV</a></td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <div class="callout callout-info">
      <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
      <p>Es sind keine Reservierungen vorhanden</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
    model () {
      this.items = []
    },
    language () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Tables/ReservationsTable.vue